import useMemoryGameActivity from './useMemoryGameActivity.hook';
import { StyledMemoryGameActivity } from './MemoryGameActivity.styled';
import MemoryGame from './MemoryGame/MemoryGame';

export default function MemoryGameActivity({
  activity,
  activityConf,
  taskProgressAPI,
  demoMode,
  onFinishedActivity,
}) {
  const { actions } = useMemoryGameActivity({
    taskProgressAPI,
    onFinishedActivity,
  });
  return (
    <StyledMemoryGameActivity>
      <MemoryGame
        gameAssetsFolder={`${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${
          process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT == 'production'
            ? 'production'
            : 'staging'
        }/gamesSrc/classic/assets/${activity.data.lesson}`}
        commonAssetsFolder={
          process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
          '/commonGameAssets/classic'
        }
        activityData={activity.data}
        activityConf={activityConf}
        onCorrectAnswer={actions.onCorrectAnswer}
        onFinishedActivity={actions.onFinishedActivity}
        language={activity.language}
      />
    </StyledMemoryGameActivity>
  );
}
